import React from 'react';
import Carousel from 'react-bootstrap/Carousel';

export default function HomeCarousel() {
    return(
        <div className='carousel'>
            <Carousel fade>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/Walt-and-Jackie-standing-back-to-back.jpg'
                        alt='Walt &amp; Jackie back to back with guitars'
                    />
                    {/* <Carousel.Caption>
                        <h3>Walt &amp; Jackie</h3>
                        <p>Photo taken by Scott Miller Photography at Cambria Iron Company, Blacksmith Shop</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/PPAC-xmas-show-silent-night-2016.jpeg'
                        alt='Walt, Jackie, Denise and Sam on stage at PPAC'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/CD release party picture.jpeg'
                        alt='Walt &amp; Jackie CD release party'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/ebensburg_gazebo_for_web.jpg'
                        alt='Walt &amp; Jackie CD release party'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/eric-beag-pushup-ppac-2019.jpg'
                        alt='Eric Shawley and Beagan the Border Collie entertaining at PPAC Hometown Holidays show'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/bongo-pic-summerhill.jpg'
                        alt='Walt &amp; Jackie silly bongo playing'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/walt-ebensburg-gazebo.jpg'
                        alt='Walt Churchey singing'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/flood-city-music-fest.jpeg'
                        alt='Walt, Jackie, Sam and Jim at Flood City Music Festival 2018'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/library-window-w-and-j.jpeg'
                        alt='Walt &amp; Jackie drawn on CC Library window'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/jackie-guitar-ppac-2019.jpg'
                        alt='Jackie Kopco singing'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/blowing-snow-promo-photo.jpg'
                        alt='Walt &amp; Jackie blowing snow at camera'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/legends-whole-stage.jpeg'
                        alt='Walt, Jackie, Sam, Jim and Denise at PPAC Legends show'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/Walt and Jackie Jim Price sketch 052119.jpeg'
                        alt='Jim Price sketch of Walt &amp; Jackie'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/walt-jack-singing-ppac-2019.jpg'
                        alt='Walt &amp; Jackie singing at PPAC Hometown Holidays show'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item interval={3000}>
                    <img
                        className='carousel-img'
                        src='/images/carousel photos/xmas-grande-hall.jpeg'
                        alt='Walt, Jackie, Jim and Eric at Grande Hall'
                    />
                    {/* <Carousel.Caption>
                        <h3>A Walt &amp; Jackie Christmas</h3>
                        <p>Walt &amp; Jackie are joined by Denise Baldwin and Sam Coco in an a capella rendition of 'Silent Night'</p>  
                    </Carousel.Caption> */}
                </Carousel.Item>
            </Carousel>
        </div>
    );
}